import { ReactNode, useState } from "react";
import ManagerCodeModal from "./manager-code-modal/ManagerCodeModal";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../hooks";

export const ManagerRoute = ({ children }: { children: ReactNode }) => {
  const [isManagerCodeModalOpen, setIsManagerCodeModalOpen] = useState(true);
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);

  return (
    <>
      {children}
      <ManagerCodeModal
        open={isManagerCodeModalOpen}
        onClose={() => {
          navigate("/pos/lobby");
        }}
        title={"Cash Register"}
        task={"to access cash register"}
        onDone={() => {
          setIsManagerCodeModalOpen(false);
        }}
        requestedByUserId={user?.id}
        actionType="CASH_REGISTER_ACCESS"
      />
    </>
  );
};
